var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel';
import Paper from '@material-ui/core/Paper/Paper';
import Radio from '@material-ui/core/Radio/Radio';
import withStyles from '@material-ui/core/styles/withStyles';
import * as React from 'react';
import ComponentForm from '../ComponentForm';
import { styles } from './radioForm.style';
/**
 * RadioForm component
 */
var RadioForm = /** @class */ (function (_super) {
    __extends(RadioForm, _super);
    /**
     * RadioForm constructor
     * @param props
     */
    function RadioForm(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Handle change for radio button
         */
        _this.handleChange = function () {
            _this.setState({ value: _this.props.id });
            _this.callback(0);
        };
        _this.state = { value: _this.props.initialValue };
        return _this;
    }
    /**
     * RadioForm render method
     */
    RadioForm.prototype.render = function () {
        var cardClass;
        var imgClass;
        var radioLabelClass;
        var radioClass;
        var _a = this.props, checked = _a.checked, label = _a.label;
        if (this.props.classes) {
            var _b = this.props.classes, card = _b.card, img = _b.img, radio = _b.radio, radioLabel = _b.radioLabel;
            cardClass = "" + card + (checked ? ' active' : '');
            imgClass = "" + img + (checked ? ' active' : '');
            radioLabelClass = "" + radioLabel + (checked ? ' active' : '');
            radioClass = radio;
        }
        var pictureUrl = this.props.assetUrl + "img/radio/ic-" + this.state.value + ".svg";
        return (React.createElement(Paper, { className: cardClass, onClick: this.handleChange },
            this.props.assetUrl
                ? React.createElement("img", { className: imgClass, src: pictureUrl, alt: "" })
                : undefined,
            React.createElement(FormControlLabel, { className: radioLabelClass, label: label, control: React.createElement(Radio, { className: radioClass, checked: checked, value: this.state.value, name: "radio-button-demo" }) })));
    };
    return RadioForm;
}(ComponentForm));
export default withStyles(styles)(RadioForm);
//# sourceMappingURL=RadioForm.js.map